import { AbstractControl, ValidatorFn } from '@angular/forms';

export function NoWhiteSpaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value && /\s/.test(control.value)) {
            return { noWhitespace: true };
        }
        return null;
    };
}
